import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

export default function Modal({ title, onClose, children, busy = false }) {
  const ref = useRef(null);
  const busyRef = useRef(busy);
  busyRef.current = busy;
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    ref.current?.querySelector('button, input, textarea')?.focus();
    const keydown = (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        if (!busyRef.current) onClose();
      }
      if (event.key !== 'Tab') return;
      const nodes = [...ref.current.querySelectorAll('button, input, textarea, select, a[href]')].filter((node) => !node.matches(':disabled') && node.tabIndex >= 0 && node.offsetParent !== null);
      if (!nodes.length) {
        event.preventDefault();
        ref.current.focus();
        return;
      }
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    };
    document.addEventListener('keydown', keydown);
    return () => {
      document.body.style.overflow = overflow;
      document.removeEventListener('keydown', keydown);
      previous?.focus();
    };
  }, [onClose]);
  return (
    <div className="profile-modal-backdrop">
      <section className="profile-modal" role="dialog" aria-modal="true" aria-label={title} ref={ref} tabIndex={-1}>
        <div className="profile-modal-heading">
          <h2>{title}</h2>
          <button className="site-icon" title="Zavřít" aria-label="Zavřít" onClick={onClose} disabled={busy}>
            <X size={20} />
          </button>
        </div>
        {children}
      </section>
    </div>
  );
}
